module.exports = __webpack_public_path__ + "static/media/logo-alt.980da429.svg";